import React from 'react';
import { ContentfulArticle } from './Blog';
import MorePosts from './MorePosts';
import { marked } from 'marked';
import { 
  Content,
  Eyebrow,
  LayoutContainer,
  LeftColumn,
  MetaDate,
  MetaInfo,
  MetaItem,
  MetaLink,
  MetaTag,
  MetaTags,
  RightColumn,
  Title 
} from './Article-styled';
import CategoryList from './CategoryList';

interface ArticleProps {
  article: ContentfulArticle;
  blogUrl?: string;
  contentfulTagId?: string;
}

const Article: React.FC<ArticleProps> = ({ article, blogUrl, contentfulTagId }) => {
  const { title, date, content, tags, categories, authors } = article.fields;
  const currentCategoryId = categories && categories.length > 0 ? categories[0].sys.id : '';

  const renderDate = (date: string) => {
    return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: '2-digit' });
  };

  return (
    <LayoutContainer>
      <LeftColumn>
        <div>
          <Eyebrow>
            <a href={blogUrl}>Home</a> / {title}
          </Eyebrow>
          <Title>{title}</Title>
        </div>
        <MetaInfo>
          {authors?.map(author => (
            <MetaItem>
              <MetaLink href={`${blogUrl}?author=${author.sys.id}`}>
                {author.fields.title}
              </MetaLink>
            </MetaItem>
          ))}
          {categories?.map(category => (
            <MetaItem $hide="mobile">
              <MetaLink href={`${blogUrl}?cat=${category.sys.id}`}>
                {category.fields.title}
              </MetaLink>
            </MetaItem>
          ))}
          {date && (            
            <MetaItem>
              <MetaDate>{renderDate(date)}</MetaDate>
            </MetaItem>
          )}
        </MetaInfo>
        <Content dangerouslySetInnerHTML={{__html: marked(content)}} />
        {tags && tags.length > 0 && (
          <MetaTags>
            {tags.map(tag => (
              <MetaTag key={tag.sys.id} href={`${blogUrl}?tag=${tag.sys.id}`}>
                {tag.fields.title}
              </MetaTag>
            ))}
          </MetaTags>
        )}
        <MorePosts blogUrl={blogUrl} contentfulTagId={contentfulTagId} />
      </LeftColumn>
      <RightColumn>
        <p>Categories</p>
        <CategoryList blogUrl={blogUrl} contentfulTagId={contentfulTagId} />
      </RightColumn>
    </LayoutContainer>
  );
};

export default Article;